import Contacts from "@/features-root-user/contacts";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_root/root-user/customer/contacts")({
  component: Contacts,
});
